import { FC, useMemo } from 'react';
import { connect } from 'react-bootstrap-formutil';
import Email from 'components/forms/Email';
import TelcodesPhone from 'components/forms/TelcodesPhone';
import VerifyCodeSend from 'components/VerifyCodeSend';
import { ContactInformationProps } from './type';

const ContactInformation: FC<ContactInformationProps> = ({ emailOptions, phoneOptions, disabled, $formutil }) => {
    const {
        isPreview: emailIsPreview,
        defaultValue: emailDefaultValue,
        placeholder: emailPlaceholder,
        className: emailClassName,
        show: emailShow = true
    } = emailOptions || {};
    const { isPreview: phoneIsPreview, defaultPhone, defaultTelCode, show: phoneShow = true } = phoneOptions || {};
    const disabledEmail = useMemo(() => Boolean(disabled || emailIsPreview), [disabled, emailIsPreview]);
    const disabledPhone = useMemo(() => Boolean(disabled || phoneIsPreview), [disabled, phoneIsPreview]);
    // phoneOptions存在且show为true才展示Phone
    const havePhone = useMemo(() => Boolean(phoneOptions && phoneShow), [phoneOptions, phoneShow]);
    // emailOptions存在且show为true才展示Email
    const haveEmail = useMemo(() => Boolean(emailOptions && emailShow), [emailOptions, emailShow]);
    const { $errors, $params } = $formutil;

    return (
        <div className="contact-info-root">
            {haveEmail && (
                <>
                    <Email
                        label={__('Email Address')}
                        disabled={disabledEmail}
                        placeholder={emailPlaceholder}
                        $defaultValue={emailDefaultValue || ''}
                        className={emailClassName}
                    />
                    {!disabledEmail && (
                        <VerifyCodeSend
                            type="email"
                            label={__('Verification Code')}
                            disabled={!!$errors.email}
                            username={$params.email}
                            process="bind_email"
                        />
                    )}
                </>
            )}
            {havePhone && (
                <>
                    <TelcodesPhone
                        label={__('Phone Number')}
                        defaultTelCode={defaultTelCode}
                        phoneOptions={{
                            $defaultValue: defaultPhone || ''
                        }}
                        disabled={disabledPhone}
                    />
                    {!disabledPhone && (
                        <VerifyCodeSend
                            type="phone"
                            label={__('Verification Code')}
                            disabled={!!$errors.phone}
                            tel_code={$params.tel_code}
                            username={$params.phone}
                            process="bind_phone"
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default connect(ContactInformation);
export * from './type';
